import { useEffect } from 'preact/hooks'
import { asset } from '$fresh/runtime.ts'
import { matchCanonical } from 'site/utils/matchCanonical.ts'

/**
 * @title Dados do script
 * @titleBy url
 */
export interface ScriptProps {
    /**
     * @title URL
     */
    url: string

    /**
     * @title ID do script
     */
    htmlID: string

    /**
     * @title Matcher
     */
    matcher?: string

    /**
     * @title Ativo?
     * @description Ativa/Desativa a execução do script
     */
    active?: boolean
}

export interface Props {
    /**
     * @title Scripts
     */
    scriptDataArray?: ScriptProps[]
}

export function loader(props: Props, _req: Request) {
    const url = new URL(_req.url)

    return {
        ...props,
        canonicalPath: url.pathname,
    }
}

function ThirdPartyScriptsNoDelay({
    scriptDataArray = [],
    canonicalPath,
}: ReturnType<typeof loader>) {
    useEffect(() => {
        scriptDataArray.forEach(
            ({ url, htmlID, matcher, active = true }) => {
                if (!active) return
                if (matcher && !matchCanonical(matcher, canonicalPath)) return

                url = url.startsWith('/') ? asset(url) : url

                const _script = document.createElement('script')
                _script.src = url
                _script.id = htmlID
                _script.async = true

                document.body.appendChild(_script)
            },
        )
    }, [])

    return null
}

export default ThirdPartyScriptsNoDelay
